import { getAmpConfig } from './amp-config';

export type Environments = 'local' | 'devci' | 'staging' | 'prod';

export const getEnv = () => getAmpConfig().env as Environments;

export const getEnvByUrl = () => {
  const url = window.location.hostname;
  let env: Environments = 'prod';
  if (url.includes('local') || url.includes('devci')) {
    env = 'devci';
  }
  if (url.includes('staging')) {
    env = 'staging';
  }
  return env;
};

export const isLocalEnvByUrl = () => {
  const url = window.location.hostname;

  return url.includes('local.amplify.com');
};

export const NAVIGATION_SETTINGS_TYPE = {
  EXTERNAL_LINK: 'EXTERNAL_LINK',
};

export const ERROR_MESSAGE = {
  PROGRAMS_NOT_SETUP: 'Your programs are not set up',
  PROGRAMS_SETUP: 'Programs are being set up',
  ERR_NOT_ENTITLED: 'Not Entitled',
  ASSIGNMENTS_ERROR: 'Assignments Error',
};

export const MODAL_ANIMATION_DURATION = 200;

export const ROTATE_X_ANIMATION_DURATION = 300;

export const REVISION_ALIAS_21_22 = '2021-2022';

export const PAGES = {
  STREAM: 'stream',
  SCHEDULED: 'scheduled',
  AVATAR: 'avatar',
  RECOMMENDATIONS: 'recommendations',
};

export const CODE_INFO_ERROR_MESSAGE =
  'Error: Expiration date loading failed. Please try again later.';
